import type { EquationTheme } from './light'
import { commonDark } from '../../_styles/common'
import { self } from './light'

const equationDark: EquationTheme = {
  name: 'Equation',
  common: commonDark,
  self
}

export default equationDark
